import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.list-po-pdf-custom-field-display.presenters.po-pdf-custom-field-display-presenter`

export default defineMessages({
  poTableTitle: {
    id: `${scope}.poTableTitle`,
    defaultMessage: 'Purchase order custom fields',
  },
  orderItemTableTitle: {
    id: `${scope}.orderItemTableTitle`,
    defaultMessage: 'Order item custom fields',
  },
})
